import { DoctorDetailsList } from "./DoctorDetailsList";
import { DoctorDiarySection } from "./DoctorDiarySection";
import { DoctorUnattachedForms } from "./DoctorUnattachedForms";

export const Mod = {
  DoctorDetailsList,
  DoctorDiarySection,
  DoctorUnattachedForms,
};
